import { useState } from "react";
import { Plus } from "lucide-react";

const entrada =
  "h-9 w-full rounded-md border border-zinc-200 bg-white px-3 text-sm text-zinc-900 placeholder:text-zinc-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 dark:border-border dark:bg-card dark:text-foreground";

/**
 * "Não achou? Adicione o seu" dos onboardings: o item entra sem origem na base (e vira candidato à
 * base no admin quando se repete entre organizações). Categoria opcional — material não tem.
 */
export function AdicionarItemProprio({
  rotulo,
  categorias,
  especialidades,
  onAdicionar,
}: {
  rotulo: string;
  /** Sugestões de categoria; sem elas o campo de categoria não aparece. */
  categorias?: string[];
  /** Procedimento da clínica: escolhe a especialidade (no lugar da categoria). */
  especialidades?: { id: string; label: string }[];
  onAdicionar: (item: { nome: string; categoria: string; especialidadeId?: string }) => void;
}) {
  const [aberto, setAberto] = useState(false);
  const [nome, setNome] = useState("");
  const [categoria, setCategoria] = useState("");
  const [especialidadeId, setEspecialidadeId] = useState(especialidades?.[0]?.id ?? "");
  const comCategoria = !!categorias && !especialidades;
  const especialidade = especialidades?.find((e) => e.id === especialidadeId);
  const valido = nome.trim().length >= 2 && (!comCategoria || categoria.trim().length > 0) && (!especialidades || !!especialidade);

  const adicionar = () => {
    if (!valido) return;
    onAdicionar(
      especialidade
        ? { nome: nome.trim(), categoria: especialidade.label, especialidadeId: especialidade.id }
        : { nome: nome.trim(), categoria: categoria.trim() },
    );
    setNome("");
  };

  if (!aberto) {
    return (
      <button
        type="button"
        onClick={() => setAberto(true)}
        className="inline-flex items-center gap-1.5 rounded-md border border-dashed border-zinc-300 px-3 py-2 text-xs font-semibold text-zinc-600 hover:border-brand-300 hover:text-brand-700 dark:border-border dark:text-muted-foreground"
      >
        <Plus className="h-3.5 w-3.5" />
        {rotulo}
      </button>
    );
  }
  return (
    <div className="flex flex-wrap items-end gap-2 rounded-lg border border-zinc-200 bg-zinc-50/60 p-3 dark:border-border dark:bg-muted/30">
      <label className="min-w-[180px] flex-1 space-y-1">
        <span className="text-[11px] font-medium text-zinc-600 dark:text-muted-foreground">Nome</span>
        <input
          autoFocus
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && adicionar()}
          className={entrada}
        />
      </label>
      {especialidades && (
        <label className="min-w-[180px] flex-1 space-y-1">
          <span className="text-[11px] font-medium text-zinc-600 dark:text-muted-foreground">Especialidade</span>
          <select value={especialidadeId} onChange={(e) => setEspecialidadeId(e.target.value)} className={entrada}>
            {especialidades.map((e) => (
              <option key={e.id} value={e.id}>
                {e.label}
              </option>
            ))}
          </select>
        </label>
      )}
      {comCategoria && (
        <label className="min-w-[180px] flex-1 space-y-1">
          <span className="text-[11px] font-medium text-zinc-600 dark:text-muted-foreground">Categoria</span>
          <input list="categorias-do-item-proprio" value={categoria} onChange={(e) => setCategoria(e.target.value)} className={entrada} />
          <datalist id="categorias-do-item-proprio">
            {categorias!.map((c) => (
              <option key={c} value={c} />
            ))}
          </datalist>
        </label>
      )}
      <button
        type="button"
        disabled={!valido}
        onClick={adicionar}
        className="h-9 rounded-md bg-brand-600 px-3 text-sm font-semibold text-white shadow-sm hover:bg-brand-700 disabled:opacity-50"
      >
        Adicionar
      </button>
      <button type="button" onClick={() => setAberto(false)} className="h-9 rounded-md px-3 text-sm text-zinc-600 hover:bg-zinc-100 dark:text-muted-foreground dark:hover:bg-muted">
        Fechar
      </button>
    </div>
  );
}
